import { MinimalLogger } from "../shared/src/types/minimalLogger"

export interface validatorStoreModel {
  logger:MinimalLogger
  validate: (fn:Function) => Boolean
}

export class MinimalConsoleLogger implements MinimalLogger {
  silly(message: string)  { console.log(message) }
  debug(message: string)  { console.log(message) }
  verbose(message: string){ console.log(message) }
  info(message: string)   { console.log(message) }
  http(message: string)   { console.log(message) }
  warn(message: string)   { console.log(message) }
  error(message: string)  { console.log(message) }
}

export type validatorOptions = {
  verbose?:boolean,
}

class validatorStore {

  logger:MinimalLogger

  constructor() {
    this.logger = new MinimalConsoleLogger()
  }

  validate(fn:Function, opts:validatorOptions = {}) {
    // console.log(`Called to validate via store. Fn:`, fn)
    try {
        fn()
        return true
    }
    catch (e:any) {
        if (opts.verbose) this.logger?.error(e)
        return false
    }
  }

}

const exportValidatorStore = new validatorStore()

export default exportValidatorStore
